import React from 'react'

export default function Down({fill ="#767676"}) {
  return (
    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.27707 5.07993L4.51151 7.96092V0H3.48849V7.96092L0.722933 5.07993L0 5.83304L4 10L8 5.83304L7.27707 5.07993Z" fill={fill} />
    </svg>
  )
}
